import { Intent } from 'signup-constants/Intent';
import { getFlowConfig } from '../../flow-initial/getFlowConfig';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { Step } from '../../views/Step';
import { isIntent } from '../../utils/isIntent';
export const BranchMicroapps = {
  name: 'BranchMicroapps',
  stateCheck: () => {
    return isIntent(Intent.clipCreator) || isIntent(Intent.campaignAssistant) || isIntent(Intent.blogIdeasGenerator);
  },
  rebuildFlow: (flow, state, dispatch) => {
    if (isIntent(Intent.campaignAssistant) || isIntent(Intent.clipCreator)) {
      getFlowConfig().shouldHalveProgressBar = true;
    }

    return dispatch(FlowStateManager.removeSteps([Step.CrmExperienceLevel]));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};